import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../../components/headers/AdminHeader';
import iconTitle from '../../assets/img/icon-square.svg';
import {
  fetchGuardControlSeihoHikiukeList,
  saveGuardControlSeihoHikiukeList,
} from '../../services/api/GuardControlService';
import { showSuccessDialog } from '../../providers/ErrorDialogProvider';
import { getInsuranceTypeShortName } from '../../utils/insuranceTypeUtils';
import { formatDateTimeForDisplay } from '../../utils/dateFormatter';
import '../../styles/GuardControlSeihoHikiukeList.css';
import '../../styles/button.css';

const GuardControlSeihoHikiukeList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const loadGuardControls = async () => {
    try {
      setLoading(true);
      const response = await fetchGuardControlSeihoHikiukeList();
      setRows(Array.isArray(response) ? response : []);
    } catch (error) {
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadGuardControls();
  }, []);

  const handleToggle = (insuranceCompanyId) => {
    setRows((prev) =>
      prev.map((row) =>
        row.insurance_company_id === insuranceCompanyId
          ? { ...row, is_guarded: !row.is_guarded }
          : row
      )
    );
  };

  const handleSave = async () => {
    const guardedCompanyIds = rows
      .filter((row) => row.is_guarded)
      .map((row) => row.insurance_company_id);

    try {
      setSaving(true);
      const response = await saveGuardControlSeihoHikiukeList(guardedCompanyIds);
      setRows(Array.isArray(response) ? response : []);
      showSuccessDialog('引受目安ガード制御を保存しました。');
    } catch (error) {
      // エラーダイアログ表示はBaseApiServiceで行う
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="header-container-admin">
      <AdminHeader onMenuToggle={() => {}} />
      <div className="page-container">
        <div className="content-wrapper">
          <div className="guard-control-list-container">
            <div className="page-header">
              <div className="title-section">
                <div className="icon-square">
                  <img src={iconTitle} alt="icon" />
                </div>
                <h1>引受目安ガード制御一覧</h1>
              </div>
            </div>

            {loading ? (
              <div className="loading">読み込み中...</div>
            ) : (
              <div className="table-scroll-container">
                <table className="guard-control-table">
                  <thead>
                    <tr>
                      <th className="no-column">No.</th>
                      <th className="insurance-type-column">保険種別</th>
                      <th className="document-type-column">文書種別</th>
                      <th className="company-column">保険会社</th>
                      <th className="datetime-column">制御開始日時</th>
                      <th className="checkbox-column">ガード制御</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length > 0 ? (
                      rows.map((row, index) => (
                        <tr key={row.insurance_company_id}>
                          <td>{index + 1}</td>
                          <td>{getInsuranceTypeShortName(row.insurance_type_id)}</td>
                          <td>{row.document_type_name}</td>
                          <td>{row.insurance_company_name}</td>
                          <td>
                            {formatDateTimeForDisplay(row.guard_started_at)}
                          </td>
                          <td>
                            <label className="checkbox-native-box">
                              <input
                                type="checkbox"
                                checked={row.is_guarded}
                                onChange={() => handleToggle(row.insurance_company_id)}
                                disabled={saving}
                                className="checkbox-native"
                              />
                            </label>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="no-data">
                          データがありません
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className="button-group button-group--mt-l c-justify-center">
            <button
              type="button"
              className="button button-secondary button-medium"
              onClick={() => navigate(-1)}
            >
              戻る
            </button>
            <button
              type="button"
              className="button button-primary button-medium"
              onClick={handleSave}
              disabled={loading || saving}
            >
              保存
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuardControlSeihoHikiukeList;
